import React from "react";
import type { IColumn } from "@fluentui/react";
import type { UUID } from "../../utils/uuid";
import { observer } from "mobx-react";
import { computed, makeObservable } from "mobx";
import type { StationaryUnit } from "../../api";

interface ListStationaryUnitItemCellProps {
    readonly stationaryUnitId: UUID;
    readonly column: IColumn;
}
import { store } from "../../store";

@observer
export class ListStationaryUnitItemCell extends React.Component<ListStationaryUnitItemCellProps> {
    constructor(props: ListStationaryUnitItemCellProps) {
        super(props);
        makeObservable(this);
    }

    @computed private get stationaryUnit(): StationaryUnit | undefined {
        return store.repositoryStationaryUnits.byId(this.props.stationaryUnitId);
    }

    public render(): JSX.Element {
        const { column } = this.props;
        if (!this.stationaryUnit) {
            return <></>;
        }
        switch (column.key) {
            case "serialNumber":
                return <span>{this.stationaryUnit.serialNumber}</span>;
            case "label":
                return <span>{this.stationaryUnit.label}</span>;
            case "createdAt":
                return (
                    <span>
                        {this.stationaryUnit
                            ? store.i18n.formatDateOnly(this.stationaryUnit.createdAt)
                            : ""}
                    </span>
                );
            case "firmwareLastUpdatedAt":
                return (
                    <span>
                        {this.stationaryUnit
                            ? store.i18n.formatDateOnly(this.stationaryUnit.firmwareLastUpdatedAt)
                            : ""}
                    </span>
                );
            case "firmwareCurrentVersion":
                return <span>{this.stationaryUnit?.firmwareCurrentVersion ?? ""}</span>;
            default:
                return <></>;
        }
    }
}
